import { useEffect, useState } from 'react';

/** Valor que se actualiza tras `ms` milisegundos sin cambios (búsquedas al escribir). */
export function useDebounced<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return debounced;
}
